import type { ReactNode } from 'react'

import { typographyVariants } from '@ui/web/lib'
import cn from '@config/tailwind/cn'

interface CtaPanelProps {
  title: string
  description?: string
  children: ReactNode
}

/** The closing call to action on the persona pages: a rounded navy card, inset from the edges. */
export function CtaPanel({ title, description, children }: CtaPanelProps) {
  return (
    <section className='px-3 pb-16 md:px-6 md:pb-20'>
      <div className='bg-navy-100 text-neutral-white mx-auto flex max-w-340 flex-col items-center gap-3.5 rounded-[28px] px-4 py-16 text-center md:rounded-[40px] md:px-8 md:py-20'>
        <h2 className={typographyVariants({ variant: 'headline-lg' })}>{title}</h2>
        {description && <p className={cn(typographyVariants({ variant: 'body-lg' }), 'max-w-160')}>{description}</p>}
        <div className='mt-3 flex flex-wrap justify-center gap-3'>{children}</div>
      </div>
    </section>
  )
}
